import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  model,
  viewChild,
} from '@angular/core';
import {
  DEFAULT_HIRE_MESSAGE,
  HIRE_MESSAGE_FIRSTNAME_TOKEN,
  insertHireMessageToken,
} from '@/app/common/hire-message.util';

@Component({
  selector: 'atom-hire-message-editor',
  templateUrl: './hire-message-editor.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HireMessageEditor {
  /** Two-way bound template body. */
  message = model<string>('');

  /** When true, the saved message is sent on hire. */
  enabled = model<boolean>(false);

  /** When true, textarea and toggle are read-only. */
  readonly = model<boolean>(false);

  private readonly textareaRef = viewChild<ElementRef<HTMLTextAreaElement>>('messageInput');

  protected readonly firstNameToken = HIRE_MESSAGE_FIRSTNAME_TOKEN;

  onEnabledToggle(): void {
    if (this.readonly()) {
      return;
    }
    const next = !this.enabled();
    this.enabled.set(next);
    if (next && !this.message().trim()) {
      this.message.set(DEFAULT_HIRE_MESSAGE);
    }
  }

  insertFirstNameToken(event: Event): void {
    event.preventDefault();
    if (this.readonly()) {
      return;
    }
    const textarea = this.textareaRef()?.nativeElement;
    const { body, cursor } = insertHireMessageToken(
      this.message(),
      HIRE_MESSAGE_FIRSTNAME_TOKEN,
      textarea?.selectionStart ?? null,
      textarea?.selectionEnd ?? null,
    );
    this.message.set(body);
    setTimeout(() => {
      if (!textarea) {
        return;
      }
      textarea.focus();
      textarea.setSelectionRange(cursor, cursor);
    });
  }

  onMessageInput(event: Event): void {
    const target = event.target as HTMLTextAreaElement;
    this.message.set(target.value);
  }
}
